import gql from 'graphql-tag';

const updateFeatureFlagMutation = gql`
  mutation updateFeatureFlag($input: UpdateFeatureFlagMutationInput!) {
    updateFeatureFlag(input: $input) {
      success
      errors
    }
  }
`;

export default updateFeatureFlagMutation;
